import React, { useEffect } from "react"; // Don't forget to import useEffect
import BuilderRightSideBar from "../../Layouts/BuilderRightSideBar";
import EditMultiPositionFields from "../../components/PositionEditElements/EditMultiPositionFields";
import EditPositionFields from "../../components/PositionEditElements/EditPositionFields";
import PositionScreenActionBar from "./FloatActionBar/PositionScreenActionBar";
import useEditElement from "./PositionedHooks/useEditElement";
import useSaveConfig from "./PositionedHooks/useSaveConfig";
import PositionedScreen from "./PositionedScreen";
import { useScreenLayoutInfo } from "./PositionedHooks/useScreenLayoutInfo";

function PositionScreenWithEdit({
  layoutConfig,
  selectedItem,
  setSelectedItem,
  setLayoutConfig,
  tableId,
  tableType,
  device = "desktop",
  buttonElements,
  onClick,
  jobPlaces,
  targetFolderPath = [],
  onScreenLayoutInfoChange,
  ...rest
}) {
  const [screenLayoutInfo, setScreenLayoutInfo] = useScreenLayoutInfo(device);

  useEffect(() => {
    onScreenLayoutInfoChange?.(screenLayoutInfo);
  }, [screenLayoutInfo, onScreenLayoutInfoChange]);

  const { screenMode: type, gridSize, showTree, showGrid, scaleFactor } = screenLayoutInfo;

  const { editElement, openEditBar, closeEditBar, openMultiFieldEditBar } = useEditElement({
    layoutConfig,
    setSelectedItem,
    buttonElements,
    onClick,
    device
  });

  const { saveEditElement, saveElementClasses, saveElementDimensions } = useSaveConfig({
    layoutConfig,
    setLayoutConfig,
    editElement
  });

  return (
    <>
      <PositionedScreen
        {...{
          layoutConfig,
          setLayoutConfig,
          selectedItem,
          setSelectedItem,
          openEditBar,
          openMultiFieldEditBar,
          closeEditBar,
          device,
          tableId,
          tableType,
          gridSize,
          type,
          showGrid,
          scaleFactor,
          showTree,
          setShowTree: (value) =>
            setScreenLayoutInfo((prev) => ({
              ...prev,
              showTree: value
            })),
          ...rest
        }}
      />

      <BuilderRightSideBar
        isOpen={editElement.show}
        onClose={closeEditBar}
        heading={editElement.heading}
        style={{ overflow: "scroll" }}
      >
        {editElement.type === "single_field" && (
          <EditPositionFields
            editElementRightsidebar={editElement.config}
            saveElement={saveEditElement}
            smId={tableId || ""}
            tableType={tableType || ""}
            device={device}
            handleClasses={saveElementClasses}
            handleStyle={saveElementDimensions}
            jobPlaces={editElement.config.jobPlaces || jobPlaces}
            targetFolderPath={[...targetFolderPath, ...editElement.config.folderIds]}
            gridSize={gridSize}
          />
        )}

        {editElement.type === "multi_field" && (
          <EditMultiPositionFields
            elements={editElement.config.items}
            type={editElement.config.type}
            handleClasses={saveElementClasses}
          />
        )}
      </BuilderRightSideBar>

      <PositionScreenActionBar
        screenLayoutInfo={screenLayoutInfo}
        setScreenLayoutInfo={setScreenLayoutInfo}
        device={device}
      />
    </>
  );
}

export default PositionScreenWithEdit;
